import i18next from "i18next";
import Select from "react-select";
import { useAllYears } from "../api/hooks/useRiskThemes";
import {
  defaultFilterTypeNumber,
  defaultSelectFilterType,
} from "../types/selectFilter";

type typeProps = {
  year: defaultFilterTypeNumber;
  setYear: (ano: defaultFilterTypeNumber) => void;
  priorityFilter: defaultSelectFilterType[];
  setPriorityFilter: (priority: defaultSelectFilterType[]) => void;
};

export const ButtonDropdown = ({
  year,
  setYear,
  priorityFilter,
  setPriorityFilter,
}: typeProps) => {
  const allPriorities = [
    { value: "LOW", label: i18next.t("priority_options_low") },
    { value: "REGULAR", label: i18next.t("priority_options_medium") },
    { value: "HIGH", label: i18next.t("priority_options_high") },
  ];
  /*-------------------------- verificando os anos disponiveis ---------------------------*/
  const { isLoading, error, data: allYears } = useAllYears();

  const years = allYears?.map((year: number) => {
    return { value: year, label: year };
  });

  const handlePriorityChange = (selectedOptions: any) => {
    setPriorityFilter(selectedOptions || []);
  };
  const handleYearChange = (selectedOptions: any) => {
    setYear(selectedOptions);
  };

  if (error) return <p>{i18next.t("error_loading_years")}</p>;

  return (
    <div className="w-full relative top-1 right-7 grid justify-items-end mb-3 mt-1">
      <div className="flex items-center space-x-4">
        {/* priority filter */}
        <div className="flex items-center border border-gray-300 px-4 py-2 rounded-xl shadow">
          <p className="mr-2 font-openSans text-[15px] leading-[20px] tracking-[0.2px]">
            {i18next.t("priority")}
          </p>
          <Select
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            isMulti
            options={allPriorities}
            value={priorityFilter}
            placeholder={i18next.t("select_priority")}
            onChange={handlePriorityChange}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                minHeight: "32px",
                height: "32px",
                minWidth: "300px",
              }),
              valueContainer: (baseStyles) => ({
                ...baseStyles,
                height: "32px",
                padding: "0 7px",
                display: "flex",
                justifyContent: "center",
              }),
              input: (baseStyles) => ({
                ...baseStyles,
                margin: "0px",
                padding: "0px",
              }),
              option: (baseStyles) => ({
                ...baseStyles,
                fontSize: "14px",
              }),
              multiValue: (baseStyles) => ({
                ...baseStyles,
                fontSize: "14px",
                marginBottom: "7px",
              }),
              multiValueLabel: (baseStyles) => ({
                ...baseStyles,
                textAlign: "center",
                padding: "0 8px",
              }),
              placeholder: (baseStyles) => ({
                ...baseStyles,
                fontSize: "14px",
                textAlign: "center",
                marginBottom: "5px",
              }),
              indicatorSeparator: (baseStyles) => ({
                ...baseStyles,
                marginBottom: "11px",
              }),
            }}
          />
        </div>

        {/* year filter */}
        <div className="flex items-center border border-gray-300 px-4 py-2 rounded-xl shadow">
          <p className="mr-2 font-openSans text-[15px] leading-[20px] tracking-[0.2px]">
            {i18next.t("year")}
          </p>
          <Select
            hideSelectedOptions={false}
            closeMenuOnSelect={true}
            options={years}
            value={year}
            onChange={handleYearChange}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                minHeight: "32px",
                height: "32px",
                minWidth: "80px",
              }),
              valueContainer: (baseStyles) => ({
                ...baseStyles,
                height: "30px",
                padding: "0 7px",
                display: "flex",
                justifyContent: "center",
              }),
              input: (baseStyles) => ({
                ...baseStyles,
                margin: "0px",
                padding: "0px",
              }),
              option: (baseStyles) => ({
                ...baseStyles,
                fontSize: "14px",
              }),
              singleValue: (baseStyles) => ({
                ...baseStyles,
                fontSize: "14px",
                marginBottom: "7px",
              }),
              indicatorSeparator: (baseStyles) => ({
                ...baseStyles,
                marginBottom: "11px",
              }),
            }}
          />
        </div>
      </div>
    </div>
  );
};
